<div>
  <div   class="mt-3 flex-gap-15px flex-row">
    <div class="flex-100" >
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>Item Updates</mat-card-title>
          <mat-card-subtitle>
            The following updates will be made to {{ itemDetail?.tag }}. To override existing values at lower hierarchies, check the box to override.
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="ml-3">
          @if (!(isLoading | async) &&
            (dataSource | async).length > 0) {
            <div class="mat-elevation-z2 table-container">
              <table mat-table [dataSource]="dataSource | async" class="mat-elevation-z2">
                <ng-container matColumnDef="attribute">
                  <th mat-header-cell *matHeaderCellDef>Attribute</th>
                  <td mat-cell *matCellDef="let row">{{ row.attribute }}</td>
                </ng-container>
                <ng-container matColumnDef="locations">
                  <th mat-header-cell *matHeaderCellDef>Locations with Overrides</th>
                  <td mat-cell *matCellDef="let row">{{ row.locations }}</td>
                </ng-container>
                <ng-container matColumnDef="currentValue">
                  <th mat-header-cell *matHeaderCellDef>Current Value</th>
                  <td mat-cell *matCellDef="let row">{{ row.currentValue }}</td>
                </ng-container>
                <ng-container matColumnDef="newValue">
                  <th mat-header-cell *matHeaderCellDef>New Value</th>
                  <td mat-cell *matCellDef="let row">{{ row.newValue }}</td>
                </ng-container>
                @if (locationSet !== 'Location') {
                  <ng-container matColumnDef="forceOverrides">
                    <th mat-header-cell *matHeaderCellDef>Force Overrides?</th>
                    <td mat-cell *matCellDef="let row">
                      <mat-checkbox
                        [checked]="row.forceOverrides"
                        (change)="forceOverrideForAttribute(row)"
                      >Force Override?</mat-checkbox>
                    </td>
                  </ng-container>
                }
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let r; columns: displayedColumns;"></tr>
              </table>
            </div>
          }
          @if (isLoading | async) {
            <div class="loading-container-center">
              <mat-spinner diameter="60"></mat-spinner>
              <p class="loading-text">Loading item changes & overrides...</p>
            </div>
          }
          @if (!(isLoading | async) && (dataSource | async)?.length === 0) {
            <div style="text-align: center">
              No overrides found for {{ this.itemDetail?.name }}
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div  class="buttons flex-center">
    <button
      [attr.data-testid]="'add_item_cancel_button'"
      class="button-color"
      mat-raised-button
      matTooltip="Cancel"
      (click)="onNoClick()"
      >Cancel
    </button>
    <button
      [attr.data-testid]="'confirm_yes_button'"
      class="button-color"
      mat-raised-button
      matTooltip="Yes"
      [disabled]="isLoading | async"
      (click)="onSave()"
      >Save
    </button>
  </div>
</div>
